/**
 * 管理员 全部菜单 全部权限 订单管理
 * */
export const superadmin = 'superadmin';

export const claimbiz = 'claimbiz';	//业务认领
export const bizread = 'bizread';	//查看自己业务
export const bizreadnoclaim = 'bizreadnoclaim';	//查看未认领业务
export const orderread = 'orderread';	//查看自己订单
export const orderreadnoclaim = 'orderreadnoclaim';//	查看未认领订单
export const projectread = 'projectread';//	查看自己项目

export const bizreadteam = 'bizreadteam';	//查看团队业务
export const claimbizbymanager = 'claimbizbymanager';	//业务代认领
export const orderreadteam = 'orderreadteam';//	查看团队订单
export const projectreadteam = 'projectreadteam';//	查看团队项目

export const biztransfer = 'biztransfer';	//客户经理转移
export const hr = 'hr';	//人员管理
export const noticemanager = 'noticemanager';	//通知函管理
export const ordermanager = 'ordermanager';//	订单管理
export const productmanager = 'productmanager';//	产品管理
export const projectmanager = 'projectmanager';//	项目管理
export const customermanager = 'customermanager';//客户经理销售经理
export const componentmanagement = 'componentmanagement';//模板管理员
///**
// * 客户经理
// *
// * 【业务中心】-订单管理、业务管理
// * 【服务中心】-项目管理
// * 【系统管理】-个人主页
// *
// * 订单认领、查看自己订单、查看未认领订单、查看自己项目
// *
// * 订单管理
// * */
//export const salesmanager = 'salesmanager';

///**
// * 销售主管
// *
// * 【业务中心】-订单管理、业务管理
// * 【服务中心】-项目管理
// * 【系统管理】-个人主页
// * 
// * 订单认领、订单代认领、客户经理转移、查看团队订单、查看团队项目、查看未认领订单
// * 
// * 订单管理
// * */
//export const salessupervisor = 'salessupervisor';

///**
// * 设计师
// *
// * 【服务中心】-项目管理
// * 【系统管理】-个人主页
// *
// * 查看自己项目
// * 
// * 项目管理
// * */
//export const designer = 'designer';

///**
// * 设计师主管
// *
// * 【服务中心】-项目管理
// * 【系统管理】-个人主页
// * 
// * 查看自己项目
// *
// * 项目管理
// * */
//export const designersupervisor = 'designersupervisor';

///**
// * 项目管理员
// *
// * 【服务中心】-项目管理、项目设置（所有三级菜单）、排队管理
// * 【系统管理】-个人主页
// *
// * 分配设计师、导出项目列表、查看所有项目、暂停项目
// *
// * 项目管理
// * */
//export const projectmanager = 'projectmanager';

///**
// * 产品管理员
// *
// * 【生态中心】-产品管理
// * 【系统管理】-个人主页
// *
// * 添加产品、编辑产品详情、添加版本、编辑版本详情
// *
// * 产品管理
// * */
//export const productmanager = 'productmanager';

///**
// * 运营经理
// *
// * 【业务中心】-订单管理、业务管理
// * 【系统管理】-个人主页
// *
// * 订单导出、查看所有订单
// *
// * 订单管理
// * */
//export const operationmanager = 'operationmanager';

///**
// * 销售助理
// *
// * 【业务中心】-订单管理、业务管理
// * 【系统管理】-个人主页
// *
// * 订单信息更新、修改AC手机号、查看所有订单
// *
// * 订单管理
// * */
//export const salesassistant = 'salesassistant';

///**
// * HR专员
// *
// * 【系统管理】员工管理、角色管理、个人主页
// *
// * 新增用户、删除用户、密码重置、组织架构编辑
// *
// * 员工管理
// * */
//export const hr = 'hr';

export const redirectbyrole = (role) => {
  switch (role) {
    case superadmin:

    case claimbiz:
    case bizread:
    case bizreadnoclaim:
    case orderread:
    case orderreadnoclaim:

    case bizreadteam :
    case claimbizbymanager:
    case orderreadteam:
    case ordermanager:
    case biztransfer:
      // 订单管理
      return {
        order: 1,
        match: role,
        title: '订单管理',
        url: "/order"
      };
    case projectmanager:
    case projectread:
    case projectreadteam:
      // 项目管理
      return {
        order: 2,
        match: role,
        title: '项目管理',
        url: "/service"
      };
    case productmanager:
    case componentmanagement:
      // 产品管理
      return {
        order: 3,
        match: role,
        title: '产品管理',
        url: "/ecology"
      };
    case noticemanager:
    case hr:
      // 员工管理
      return {
        order: 4,
        match: role,
        title: '系统管理',
        url: "/system"
      };
    case customermanager:// 订单认领
    
    default:
      // 无任何权限
      return {
        order: 100,
        match: role,
        title: '无角色权限',
        url: "/norole.html"
      };
  }
}

export default {
  superadmin: superadmin,
  bizread,
  bizreadnoclaim,
  bizreadteam,
  biztransfer,
  claimbiz,
  claimbizbymanager,
  hr,
  noticemanager,
  ordermanager,
  orderread,
  orderreadnoclaim,
  orderreadteam,
  productmanager,
  projectmanager,
  projectread,
  projectreadteam,
  customermanager,
  componentmanagement
}



// WEBPACK FOOTER //
// ./src/common/jdyrole.js